import { createSelector } from 'reselect';

import getCartItems from './getCartItems';

const getAreOnlyDonationsItemsInCart = createSelector(getCartItems, items =>
  items?.every(item => item?.donationProduct),
);

export default getAreOnlyDonationsItemsInCart;
